import AddCircleIcon from "@mui/icons-material/AddCircle";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import PeopleOutlineIcon from "@mui/icons-material/PeopleOutline";
import { Box, ButtonBase, Typography } from "@mui/material";

export const SelectOrCreateMode = Object.freeze({
    EXISTING: "existing",
    CREATE: "create",
});

const ModeTab = ({ active, icon, label, onClick, disabled }) => (
    <ButtonBase
        onClick={onClick}
        disabled={disabled}
        aria-pressed={active}
        sx={(theme) => ({
            flex: 1,
            gap: 1,
            py: 1,
            borderRadius: 1,
            border: "1px solid",
            borderColor: active ? theme.palette.primary.main : "divider",
            backgroundColor: active
                ? `${theme.palette.primary.main}0F`
                : "background.paper",
            color: active ? "primary.main" : "text.primary",
            fontWeight: active ? 600 : 500,
            opacity: disabled ? 0.5 : 1,
        })}
    >
        {icon}
        <Typography variant="body2" fontWeight="inherit" color="inherit">
            {label}
        </Typography>
    </ButtonBase>
);

/**
 * Two-mode field: pick an existing record or create a new one.
 * Keeps the "create" action out of the dropdown so it stays visible
 * no matter how long the existing list is.
 */
const SelectOrCreateSwitch = ({
    mode,
    onModeChange,
    disabled = false,
    existingLabel = "Select Existing",
    createLabel = "Create New",
    children,
}) => {
    const isCreate = mode === SelectOrCreateMode.CREATE;

    return (
        <Box
            className="mt-3"
            sx={{
                p: 1.5,
                borderRadius: 1,
                border: "1px solid",
                borderColor: "divider",
            }}
        >
            <Box sx={{ display: "flex", gap: 1 }}>
                <ModeTab
                    active={!isCreate}
                    disabled={disabled}
                    icon={<PeopleOutlineIcon fontSize="small" />}
                    label={existingLabel}
                    onClick={() => onModeChange(SelectOrCreateMode.EXISTING)}
                />
                <ModeTab
                    active={isCreate}
                    disabled={disabled}
                    icon={<AddCircleIcon fontSize="small" />}
                    label={createLabel}
                    onClick={() => onModeChange(SelectOrCreateMode.CREATE)}
                />
            </Box>

            <Box
                sx={() => ({
                    mt: 1.5,
                })}
            >
                {children}
            </Box>
        </Box>
    );
};

export default SelectOrCreateSwitch;
